export enum MessageChannel {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export enum MessageType {
  INSTANT = 'INSTANT',
  PLANNED = 'PLANNED',
}

export enum MessageTriggerType {
  BOOKING_FINALIZED = 'BOOKING_FINALIZED',
  BOOKING_CONFIRMED = 'BOOKING_CONFIRMED',
  BOOKING_CANCELLED = 'BOOKING_CANCELLED',
  WAITLIST_ENTRY_CREATED = 'WAITLIST_ENTRY_CREATED',
  TOUR_START_REMINDER = 'TOUR_START_REMINDER',
  TOUR_END_REMINDER = 'TOUR_END_REMINDER',
  TOUR_CANCELLATION = 'TOUR_CANCELLATION',
  CUSTOM = 'CUSTOM',
}

export enum MessageStatus {
  SCHEDULED = 'SCHEDULED',
  PROCESSING = 'PROCESSING',
  SENT = 'SENT',
  SCHEDULED_FOR_RETRY = 'SCHEDULED_FOR_RETRY',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

export enum RecipientType {
  CLIENT = 'CLIENT',
  PARTICIPANT = 'PARTICIPANT',
}

export enum MessageTemplateType {
  BOOKING_CONFIRMATION = 'BOOKING_CONFIRMATION',
  TOUR_START_REMINDER = 'TOUR_START_REMINDER',
  TOUR_END_REMINDER = 'TOUR_END_REMINDER',
  TOUR_CANCELLATION = 'TOUR_CANCELLATION',
  INVITATION = 'INVITATION',
  BOOKING_CHANGE_PENDING = 'BOOKING_CHANGE_PENDING',
  BOOKING_CHANGE_APPLIED = 'BOOKING_CHANGE_APPLIED',
  BOOKING_WITHDRAWN = 'BOOKING_WITHDRAWN',
  CONSENT_PENDING = 'CONSENT_PENDING',
  CUSTOM = 'CUSTOM',
}
